
if(document.getElementsByClassName('foldersGridBlock').length >=0){
    require('./folders.js');
    try {
        require('selectize');
    } catch (e) {
        console.error('Unable to load selectize module' + e);

    }
    require('./selection.js');
    require('./shareToEmail.js');
}
